/*
 * Fügt bei einem String alle n-Stellen (after) ein Leerzeichen ein.
 * Ist das Ende des Strings gleich n (after) wird kein Leerzeichen hinzugefügt.
 */

export const insertSpaceEveryNChars = (value: string, after = 4) => {
  if (!value) {
    return '';
  }
  // Replace: Löscht alles, außer Zahlen und Großbuchstaben
  const val = value.toUpperCase().replace(/[^\dA-Z]/g, '');
  const reg = new RegExp('.{' + after + '}(?!$)', 'g');
  return val.replace(reg, function (a) {
    return a + ' ';
  });
};
